import React from 'react'
import Appbar from './Appbar'

const SliderC = () => {
  return (
    <div className='hero-sec'>
      <Appbar />
      <img src='assets/Hero/BannerM1.jpg' alt='' />
    </div>
  )
}

export default SliderC